<!-- <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    {{node.name}}
  </mat-tree-node>
  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
    <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    {{node.name}}
  </mat-tree-node>
</mat-tree> -->

<div class="card">
  <div class="card-header card-header-squirrel">
    <!-- <h4>{{this.translate.data['ADDUSER'] | translate}}</h4>         -->
    <h4>Projektgruppenrollen auswählen</h4>        
  </div>
  <div class="card-body">
    <div class="dialog-content">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- Knoten ohne Kinder -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <mat-checkbox [checked]="node.checked" (change)="toggleCheck(node)">
            {{ node.name }}
          </mat-checkbox>
        </mat-tree-node>
  
        <!-- Knoten mit Kindern -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <div class="node-header">
            <button mat-icon-button (click)="treeControl.toggle(node)">
              <mat-icon>
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <mat-checkbox [checked]="node.checked" (change)="toggleCheck(node)">
              {{ node.name }}
            </mat-checkbox>
          </div>
          <div *ngIf="treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </mat-nested-tree-node>
      </mat-tree>

      <div class="row">
        <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                            (click)="cancel()" >Abbruch</button>
        </a>                                                
        <span style="flex: 1 1 auto"></span>
        <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPADDUSERDIALOG'] | translate}}"
                                (click)="add()" >Hinzufügen</button>
        </a>                   
      </div>    
    </div>
  </div>
</div>

<!-- <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <mat-checkbox [checked]="node.checked" (change)="toggleCheck(node)">
      {{ node.name }}
    </mat-checkbox>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
    <mat-checkbox [checked]="node.checked" (change)="toggleCheck(node)">
      {{ node.name }}
    </mat-checkbox>
    <mat-tree-node-toggle>
      <mat-icon class="mat-icon-rtl-mirror">
        {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </mat-tree-node-toggle>
    <div *ngIf="treeControl.isExpanded(node)">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-tree-node>
</mat-tree> -->
